import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h4l3 8l4 -16l3 8h4","key":"svg-0"}]]

const IconActivity = createReactComponent('outline', 'activity', 'Activity', __iconNode);

export default IconActivity;